/**
 * ics 端状态
 */
export default {
  state: {
    icsShowState: 1, // 是否在icsapp中显示： 1 默认显示  0 隐藏
    icsSharedInfo:  { shared: false, day: 1, salesId: 0 }
  },
  mutations: {
    'SET_ICS_STATUS': function (state, { icsShowState }) {
      state.icsShowState = icsShowState;
    },
    setIcsShared (state, {icsSharedInfo }) {
      state.icsSharedInfo = icsSharedInfo;
    }
  },
  getters: {
    icsShowState: state => state.icsShowState,
    icsSharedInfo: state => state.icsSharedInfo,
  },
  namespaced: true
};